import func from '../libs/functions';

const networks = {
	namespaced: true,
	state: {
		networks: [],
		networksById: {},
		networksByName: {}
	},
	getters: {
		networks(state){
			return state.networks
		},
		networksByName(state){
			return state.networksByName
		},
		networksById(state){
			return state.networksById
		}
	},
	mutations: {
		setNetworks(state, networks){
			state.networks = networks
			state.networksById = func.arrayToObject(networks, '_id')
			state.networksByName = func.arrayToObject(networks, 'name')
		}
	},
	actions: {
		setNetworks({ commit }, networks){
			commit('setNetworks', networks)
	}}
}

export default networks;


// WEBPACK FOOTER //
// ./src/store/networks.js